import React, { useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { matchPath } from 'react-router'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { QUESTIONS, TCA_STATUS } from 'src/constants/messages'
import { OVERLAY_HELPERS } from 'src/constants/navigation'
import { createTca } from 'src/actions/tca'
import {
  selectTcaRequested,
  selectTcaSuccess,
  selectTcaError,
  selectTcaReportForRefiDetails
} from 'src/store/selectors/tca'
import { If, Unless, ExternalLinkButton } from 'src/Components'
import { IconExternalLink } from 'src/Components/shared/Icon'
import history from 'src/history'

import OutreachButton from './OutreachButton'
import MortgageCoachPanel from 'src/Components/shared/InterestSection/MortgageCoach/MortgageCoachPanel'
import styles from './OutreachButton/OutreachButton.module.scss'

const propTypes = {
  type: PropTypes.string,
  term: PropTypes.number,
  rate: PropTypes.number,
  years: PropTypes.number,
  className: PropTypes.string
}

const MortgageCoachRequestButton = ({ type, term, rate, years }) => {
  const dispatch = useDispatch()
  const [didClick, setDidClick] = useState(false)

  const requested = useSelector(selectTcaRequested)
  const success = useSelector(selectTcaSuccess)
  const failure = !!useSelector(selectTcaError)
  const tcaLinkSrc = useSelector(selectTcaReportForRefiDetails({ type, years }))

  const rootMatch =
    matchPath(window.location.pathname, {
      path: OVERLAY_HELPERS.refinance.matchPath || ''
    }) || {}

  const handleClick = useCallback(() => {
    if (rootMatch.url) {
      history.push(`${rootMatch.url}/${OVERLAY_HELPERS.mortgageCoach.overlay}`)
    }
    setDidClick(true)
  }, [rootMatch.url])

  const requestTca = useCallback(() => {
    dispatch(createTca({ type, term, rate, years }))
  }, [type, term, rate, years, dispatch])

  return (
    <>
      <Unless condition={tcaLinkSrc}>
        <OutreachButton
          requested={requested}
          success={success}
          failure={failure}
          buttonMessage={QUESTIONS.mortgageCoachRequest}
          resultMessage={TCA_STATUS[success ? 'success' : 'failure']}
          handleClick={handleClick}
        />
      </Unless>
      <If condition={tcaLinkSrc}>
        <div className={styles.container}>
          <ExternalLinkButton
            className={styles.button}
            primary
            fullWidth
            iconStart={IconExternalLink}
            href={tcaLinkSrc}
          >
            <FormattedMessage
              id='MortgageCoachRequest.tca.view'
              defaultMessage='View your TCA'
            />
          </ExternalLinkButton>
        </div>
      </If>
      <MortgageCoachPanel
        routedFromRefi={didClick}
        rootMatch={rootMatch}
        refiDetails={{ years, type }}
        requestTca={requestTca}
      />
    </>
  )
}

MortgageCoachRequestButton.propTypes = propTypes

export default MortgageCoachRequestButton
